var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdt-button"},[_c('div',{staticClass:"flex-center pointer no-userselect button",class:[{
      'button-disabled': _vm.disabled,
    }, ("theme-" + _vm.theme)]},[_c('i',{class:_vm.icon})])])}
var staticRenderFns = []

export { render, staticRenderFns }